import { CircularProgress, styled } from '@mui/material';

export const FileViewerToolbar = styled('div')({
  alignItems: 'center',
  alignSelf: 'stretch',
  backgroundColor: '#F3F8FD',
  borderBottom: '1px solid #D8E3EE',
  boxSizing: 'border-box',
  display: 'flex',
  gap: 8,
  justifyContent: 'space-between',
  padding: '6px 10px 8px',
  position: 'relative',
  zIndex: 6,
});

export const FileViewerToolbarSection = styled('div')({
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  border: '1px solid #CBD5E1',
  borderRadius: 8,
  boxShadow: '0 6px 16px rgba(15, 23, 42, 0.08)',
  color: '#334155',
  display: 'inline-flex',
  gap: 3,
  minHeight: 28,
  padding: '2px 4px',
});

export const FileViewerToolbarButton = styled('button')({
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: 0,
  borderRadius: 999,
  color: '#334155',
  cursor: 'pointer',
  display: 'inline-flex',
  fontSize: 12,
  fontWeight: 700,
  height: 24,
  justifyContent: 'center',
  lineHeight: 1,
  minWidth: 24,
  padding: '0 7px',
  transition: 'background-color 160ms ease, color 160ms ease',
  '& svg': {
    fontSize: 14,
  },
  '&:hover:not(:disabled)': {
    backgroundColor: '#E4EEF8',
    color: '#035EA8',
  },
  '&[aria-pressed="true"]': {
    backgroundColor: '#DCEEFF',
    color: '#035EA8',
  },
  '&:disabled': {
    color: '#94A3B8',
    cursor: 'not-allowed',
  },
});

export const FileViewerToolbarDivider = styled('span')({
  backgroundColor: '#CBD5E1',
  display: 'inline-flex',
  height: 14,
  margin: '0 2px',
  width: 1,
});

export const FileViewerToolbarInput = styled('input')({
  backgroundColor: '#FFFFFF',
  border: '1px solid #CBD5E1',
  borderRadius: 8,
  boxSizing: 'border-box',
  color: '#0F172A',
  fontSize: 12,
  fontWeight: 700,
  height: 22,
  outline: 'none',
  textAlign: 'center',
  width: 34,
  '&:focus': {
    borderColor: '#037DE8',
    boxShadow: '0 0 0 2px rgba(3, 125, 232, 0.12)',
  },
});

export const FileViewerToolbarText = styled('span')({
  color: '#64748B',
  fontSize: 11,
  fontWeight: 700,
  lineHeight: 1,
  padding: '0 3px',
  whiteSpace: 'nowrap',
});

export const FileViewerInitialLoadOverlay = styled('div')({
  alignItems: 'center',
  background: 'linear-gradient(180deg, #F3F8FD 0%, #EEF4F8 100%)',
  color: '#475569',
  display: 'flex',
  flexDirection: 'column',
  fontSize: 'var(--file-viewer-loading-font-size, 13px)',
  fontWeight: 700,
  gap: 12,
  inset: 0,
  justifyContent: 'center',
  lineHeight: 1,
  minHeight: 240,
  pointerEvents: 'none',
  position: 'absolute',
  textAlign: 'center',
  zIndex: 4,
});

export const FileViewerResizeOverlay = styled('div')({
  alignItems: 'center',
  backdropFilter: 'blur(6px) saturate(0.96)',
  background: 'rgba(243, 248, 253, 0.72)',
  color: '#334155',
  display: 'flex',
  flexDirection: 'column',
  fontSize: 'var(--file-viewer-loading-font-size, 13px)',
  fontWeight: 700,
  gap: 10,
  inset: 0,
  justifyContent: 'center',
  lineHeight: 1,
  pointerEvents: 'none',
  position: 'absolute',
  textAlign: 'center',
  WebkitBackdropFilter: 'blur(6px) saturate(0.96)',
  zIndex: 5,
});

export const FileViewerLoadingSpinner = styled(CircularProgress)({
  color: '#037DE8',
});
